<template>
  <div class="school_settings_holder">
    <vs-tooltip color="primary" text="School Name" position="top">
    <div class="icon_holder" @click="schoolSettings = !schoolSettings">
      <span class="material-icons-outlined">school</span>
    </div>
    </vs-tooltip>
    <div class="content_holder" :class="[schoolSettings ? 'active' : '']">
      <label class="vs--input-label">School Name</label>
      <v-select v-if="fromWhere !== 'myCourse'" append-to-body :clearable="false" class="w-full" @input="getCustomerId" :options="schoolList" v-model="schoolId"  label="brand_company_name" :reduce="(item) => item.id" placeholder="School Name"></v-select>
      <v-select v-else class="w-full" append-to-body :clearable="false" @input="filterMyCourse" :options="schoolList" v-model="schoolId"  label="brand_company_name" :reduce="(item) => item.id" placeholder="School Name"></v-select>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {customer_info} from '@/api/common'
export default {
  name: 'schoolFilter',
  components: {
    vSelect
  },
  props: {
    fromWhere: {
      type: String,
      default: 'others'
    }
  },
  data () {
    return {
      schoolSettings: false,
      schoolList: [],
      schoolId: parseInt(localStorage.getItem('customer_id'))
    }
  },
  async created () {
    try {
      const data = await customer_info()
      this.schoolList = data.data.data.platform_customer
      const filterId = this.schoolList.filter((ele) => {return ele.id == localStorage.getItem('customer_id')})
      this.schoolId = filterId[0].id
    } catch (e) {
      console.log(e)
    } 
  },
  methods: {
    filterMyCourse () {
      this.schoolSettings = false
      this.$emit('filterMyCourse')
    },
    getCustomerId () {
      this.schoolSettings = false
      this.$emit('getCustomerId', this.schoolId)
    }
  }
}
</script>